import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setResponse } from "../Response/responseSlice";
import { setToast, setLoading, setModal } from "../uiSlice";
import { createUsuario, editUsuario, getUsuarios } from "../../Services/usuario_service";

const initialState = {
    usuarios: [],
    usuario: {
        idUsuario: 0,
        user: '',
        estado: 1,
        idRol: 3,
        rol: '',
    }
}



export const usuarioSlice = createSlice({
  name: "usuario",
  initialState,
  reducers: {
    setUsuarios: (state, action) => {
      state.usuarios = action.payload;
    },
    setUsuario: (state, action) => {
      state.usuario = !action.payload ? initialState.usuario : action.payload;
    },
    resetUsuario: (state) => {
      return initialState;
    },
  },
});

export const fetchUsuarios = createAsyncThunk(
    'usuario/fetchUsuarios',
    async (_, { dispatch }) => {
        const usuarioRes = await getUsuarios();
        dispatch(setUsuarios(usuarioRes));
    }
);

export const addUsuario = createAsyncThunk(
    'usuario/create',
    async (data, { dispatch }) => {
        dispatch(setLoading(true))
        const usuarioRes = await createUsuario(data);
        dispatch(setResponse(usuarioRes));
        dispatch(setLoading(false));
        dispatch(setModal(false));
        dispatch(setToast(true));
        dispatch(fetchUsuarios());
        setTimeout(() => {
            dispatch(setToast(false));
        }, 3000);
    }
);

export const EditUsuario = createAsyncThunk(
    'usuario/update',
    async (data, { dispatch }) => {
        dispatch(setLoading(true));
        console.log(data);
        const usuarioRes = await editUsuario(data);
        dispatch(setResponse(usuarioRes));
        dispatch(setLoading(false));
        dispatch(setModal(false));
        dispatch(setToast(true));
        dispatch(fetchUsuarios());
        setTimeout(() => {
            dispatch(setToast(false));
        }, 3000);
    }
);

export const { setUsuarios, setUsuario, resetUsuario } = usuarioSlice.actions;
export default usuarioSlice.reducer;